import React from "react";
import PropTypes from "prop-types";
import { getInputFieldNameValue } from "utils/commonMethods";

function TextArea({ value, onChange, placeholder, className = "" }) {
  const onChangeMiddleware = function (ev) {
    const { value } = getInputFieldNameValue(ev);
    return onChange(value);
  };

  return (
    <textarea
      className={"custom-textarea " + className}
      value={value}
      onChange={onChangeMiddleware}
      placeholder={placeholder}
    ></textarea>
  );
}

PropTypes.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

export default TextArea;
